import { SettingGroupObjectType } from '@/interfaces/settingGroupObjectType';
import { SettingGroupResource, settingGroupResource } from '@/resources/settingGroup.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł grup ustawień
 *
 * @export
 * @class SettingGroupsModule
 * @extends {EntityModule<SettingGroupObjectType, SettingGroupResource>}
 */
export class SettingGroupModule extends EntityModule<SettingGroupObjectType, SettingGroupResource> {
  constructor() {
    super(settingGroupResource);
  }
}

export default new SettingGroupModule();
